export default "__VITE_ASSET__CEcyWYVL__"